import Marquee from "react-fast-marquee";

const WORDS = ["REPAIRS", "ROAD WORTHY", "ELECTRICAL", "COMPLIANCE", "AIRCON"];

export const MarqueeStrip = () => {
  return (
    <section data-testid="marquee" className="relative bg-ink py-10 md:py-16 border-y border-surface-2 overflow-hidden">
      <Marquee speed={45} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase leading-none text-6xl md:text-8xl lg:text-9xl text-outline mx-8">
              {w}
            </span>
            <span className="text-hazard text-5xl md:text-7xl mx-8 font-display leading-none">/</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
};
